import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
//import { FinancialNetCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import plantree from '../../assets/data/plan-tree.json';
import { FinancialItemIdService } from './../services/financial-item-id.service';
import { FinancialSummaryCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-section-view-box',
    templateUrl: './section-view-box.component.html',
    styleUrls: ['./section-view-box.component.scss'],
    standalone: false
})
export class SectionViewBoxComponent implements OnInit {
  public subscription: Subscription;
  public subscription2: Subscription;
  public subscription3: Subscription;
  public subscription4: Subscription;
  public filter: string = "";
  public title = "";
  public total = 0;
  public assetTotal = 0;
  public debtTotal = 0;
  public incomeTotal = 0;
  public expenseTotal = 0;
  public myUser;
  public statusTooltipMobile: boolean = false;
  public myItemsList: {};
  public items: {}[] = [];
  public multiplier = 1;
  public templateName = "bank-account";
  public idToShow;
  public show = false;
  public canEdit = false;
  public _myCategoriesBalance: {}[];
  public questionMarkMobile: boolean;
  // @Input() myCategoriesBalance: {}[];
  @Input() public jointOwnersStats:boolean = false;
  public incomeProperty: boolean;
  @Input() set myCategoriesBalance(value: {}[]) {
    this._myCategoriesBalance = value;
    //
  }
  public mySectionList: {}[] = [];
  public summaryCategory; //assets etc.
  public collapseStatus = [];

  //@Input() templateName;
  constructor(
    private userInfo: UserInfoService,
    private financialItemsSetFilterService: FinancialSectionsSetFilterService,
    private zenplanData: ZpDataService,
    private financialItemIdService: FinancialItemIdService,
    public themeService: ThemeService,
    private financialNetCategoriesSetFilterService: FinancialSummaryCategoriesSetFilterService) {}

  async ngOnInit() {
    this.subscription = this.userInfo.getMessage().subscribe(async user => {
      this.myUser = await JSON.parse(user);
    });
    this.subscription2 = this.financialItemsSetFilterService.getMessage().subscribe(async filter => {
      if (filter != "null") {
        this.filter = filter;
        this.filterList(filter);
      }
    });
    this.subscription3 = this.financialItemIdService.getMessage().subscribe(async id => {
      let index = 0;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i]["Id"] == id) {
          index = i;
        }
      }
      //await this.filterList("property");
      //this.view(id, index);
      //this.scroll(id);
    });
    this.subscription4 = this.financialNetCategoriesSetFilterService.getMessage().subscribe(category => {
      this.summaryCategory = category;
    });
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true
    } else {
      this.questionMarkMobile = false
    }

  }

  async filterList(filter) {
    this.filter = filter;
    if (filter) {
      let basename = "";
      plantree.forEach(function (category) {
        let mySection = category.sectionObjects.filter(section => section.section == filter);
        if (mySection.length > 0) {
          basename = mySection[0].baseName;
        }
      });
      this.templateName = basename + "-view";
      this.myItemsList = await this.zenplanData.getPlanSectionInfo(this.myUser, filter);
      this.title = this.myItemsList["sectionName"];
      // if (("my debts_my daily life").includes(this.myItemsList["category"]["planCategory"])) {
      //   this.multiplier = -1;
      // }
      // else {
      //   this.multiplier = 1;
      // }
      let mySection = this._myCategoriesBalance["sections"].find(section => section["sectionName"] == filter);
      // this.total = this.myItemsList["grandTotal"] * this.multiplier;
      // this.assetTotal = this.myItemsList["assetTotal"];
      // this.debtTotal = this.myItemsList["debtTotal"];
      // this.incomeTotal = this.myItemsList["incomeTotal"];
      // this.expenseTotal = this.myItemsList["expenseTotal"];
      //using the myCategoriesBalance which have the jointownership caculations
      switch (this.summaryCategory) {
        case "assets":
          {
            this.total = mySection["assetTotal"];
            this.items = mySection["assetItems"];
            break;
          }
        case "debts":
          {
            this.total = mySection["debtTotal"];
            this.items = mySection["debtItems"];
            break;
          }
        case "income":
          {
            this.total = mySection["incomeTotal"];
            this.items = mySection["incomeItems"];
            this.incomeProperty = true
            break;
          }
        case "expenses":
          {
            this.total = mySection["expenseTotal"];
            this.items = mySection["expenseItems"];
            break;
          }
      }

      // this.assetTotal = mySection["assetTotal"];
      // this.debtTotal = mySection["debtTotal"];
      // this.incomeTotal = mySection["incomeTotal"];
      // this.expenseTotal = mySection["expenseTotal"];

      // if ("my daily life".includes(mySection["categoryName"])) {
      //   this.total = this.incomeTotal + this.expenseTotal; //it will be either a income or an expense
      // }
      // else if("my debts".includes(mySection["categoryName"])){
      //   this.total = this.debtTotal + this.expenseTotal;
      // }
      // else {
      //   this.total = this.assetTotal - this.debtTotal +
      //     this.incomeTotal - this.expenseTotal;
      // }
      //this.items = this.myItemsList["items"];

      let counter = 0;
      this.items.forEach(item => {
        this.collapseStatus[counter] = false;
        counter++;
        //item["itemTotal"] = item["itemTotal"] * this.multiplier;
      });
    }
    //     let mySectionObject = plantree.find(kk => kk.sectionObjects["section"] == filter);
    // let kkk = 0;
    // let id = await this.financialItemIdService.getId();
    // if (id) {
    //   for (let i = 0; i < this.items.length; i++) {
    //     if (this.items[i]["Id"] == id) {
    //       this.view(id, i);
    //     }
    //   }
    // }
  }

  async filterList2(filter) {

    this.mySectionList = [];
    this.total = 0;
    let mySections: {}[] = this._myCategoriesBalance["sections"];
    //this.financialSectionFilterService.changeMessage(mySections[0]["sectionName"]);
    switch (filter) {
      case "assets":
        mySections.filter(item => item["assetTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["assetItems"].length, "sectionTotal": section["assetTotal"]
          });
        });
        this.total = this._myCategoriesBalance["assetTotal"];

        break;
      case "debts":
        mySections.filter(item => item["debtTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["debtItems"].length, "sectionTotal": section["debtTotal"]
          });
        });
        this.total = this._myCategoriesBalance["debtTotal"];
        break;
      case "income":
        mySections.filter(item => item["incomeTotal"] > 0).forEach(section => {
          this.mySectionList.push({ "sectionName": section["sectionName"], "itemCount": section["incomeItems"].length, "sectionTotal": section["incomeTotal"] });
        });
        this.total = this._myCategoriesBalance["incomeTotal"];
        break;
      case "expenses":
        mySections.filter(item => item["expenseTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["expenseItems"].length, "sectionTotal": section["expenseTotal"]
          });
        });
        this.total = this._myCategoriesBalance["expenseTotal"];
        break;
    }
  }

  view(itemId, i) {
    //*ngIf="item.Id==idToShow && show"
    //click on a closed item should close any open items and open itself
    //click on a open item should just close it.
    if (this.idToShow == itemId) {
      this.collapseStatus[i] = !this.collapseStatus[i];
      this.show = !this.show;
      return;
    }
    this.financialItemIdService.changeMessage(itemId);
    this.idToShow = itemId;
    this.show = false;
    let counter = 0;
    this.items.forEach(item => {
      this.collapseStatus[counter] = false;
      counter++;
    });
    this.collapseStatus[i] = true; //!this.collapseStatus[i];
    this.show = true;
  }

  public toggleStatusTooltipMobile(): void {
    this.statusTooltipMobile = !this.statusTooltipMobile;
  }

  scroll(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

}
